import { cn } from '@/utils/tailwind-merge';

export default function TextSmall({
    children,
    className,
}: {
    children: string;
    className?: string;
}) {
    return (
        <span className={cn('text-sm font-light font-helveticaNeue', className)}>{children}</span>
    );
}
